import Swal from 'sweetalert2'

class EfForgottenPassword {
    static get $inject() {
        return ['$state', 'UsuariosService']
    }

    constructor($state, UsuariosService) {
        this.$state = $state
        this.UsuariosService = UsuariosService

        this.token = this.$state.params.token
    }

    $onInit() {
        if (this.token) {
            this.UsuariosService
                .confirmarResetPassword(this.token)
                .then(() => {
                    return Swal.fire({
                        icon: "success",
                        title: "Senha redefinida!",
                        text: "Um e-mail foi enviado com sua nova senha.",
                    })
                })
                .catch(() => {
                    return Swal.fire({
                        icon: "error",
                        title: "Erro ao redefinir senha!",
                        text: "Por favor, tente novamente em alguns instantes ou entre em contato com o suporte técnico.",
                        showLoaderOnConfirm: true
                    });
                })
                .then(() => this.$state.go('login'))
        }
    }

    submit(form) {
        if (form.$valid) {
            this.loading = true

            this.UsuariosService
                .resetPassword(this.email)
                .then(() => {
                    return Swal.fire({
                        icon: "success",
                        title: "Sucesso!",
                        text: "Um e-mail foi enviado para confirmar a operação.\nVerifique sua caixa de entrada.",
                        showLoaderOnConfirm: true
                    })
                })
                .then(() => this.$state.go('login'))
                .finally(() => this.loading = false)
        }
    }
}

angular.module('eficienciaFiscalModule')
    .component('efForgottenPassword', {
        controller: EfForgottenPassword,
        template: `
        <header class="header">
            <div id="logo-group">
                <img src="https://res.cloudinary.com/eficienciafiscal/image/upload/f_auto,fl_progressive,q_auto/v1588013281/app/logo-menu.png" alt="Logo do Eficiencia Fiscal" width="155" height="35">
            </div>
        </header>
        <main class="form-container">
            <div id="content" class="container">
                <div class="row">
                    <div class="col-xs-12 col-lg-8 hidden-xs hidden-sm">
                        <h1 class="txt-color-green login-header-big">Esqueceu a Senha?</h1>
                        <div class="hero" style="background-image: none;">
                            <h4 style="font-weight: normal;">
                                Preencha o campo ao lado para resetar sua senha.
                            </h4>
                        </div>
            
                        <div class="row">
                            <div class="col-xs-12 col-lg-6">
                                <h5 class="about-heading"></h5>
                                <p></p>
                            </div>
                            <div class="col-xs-12 col-lg-6">
                                <h5 class="about-heading"></h5>
                                <p></p>
                            </div>
                        </div>
            
                    </div>
                    <div class="col-xs-12 col-lg-4">
                        <div class="well no-padding">
                            <form name="form" class="smart-form client-form" ng-submit="$ctrl.submit(form)">
                                <header style="font-weight: normal">
                                    Recuperação de senha
                                </header>
                                <div ng-if="$ctrl.error" class="alert alert-danger fade in fade out no-margin">
                                    <i class="fa-fw fa fa-times"></i> 
                                    {{$ctrl.error}}
                                </div>
                                <fieldset>
                                    <section>
                                        <label class="label" for="email">E-mail</label>
                                        <label class="input"> 
                                            <i class="icon-append fa fa-user"></i>
                                            <input id="email" name="email" ng-model="$ctrl.email" required>
                                        </label>
                                    </section>
                                </fieldset>
                                <footer>
                                    <button class="btn btn-success btn-lg" ng-disabled="$ctrl.loading">
                                        Recuperar senha
                                        <span ng-show="$ctrl.loading">
                                            <i class="fa fa-spin fa-circle-o-notch"></i>
                                        </span>
                                    </button>
                                </footer>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </main>
        <ef-fullscreen-loading ng-if="$ctrl.token" message="'Por favor aguarde, estamos redefinindo sua senha...'"></ef-fullscreen-loading>
        `
    })
